import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@services/logic/translate.service';

/** Values for `{{name}}` placeholders in a translation string. */
export type TranslateParams = Record<string, string | number>;

const PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/g;

@Pipe({ name: 'translate', pure: true, standalone: true })
export class TranslatePipe implements PipeTransform {
  constructor(private t: TranslateService) {}

  /**
   * Needed to force trigger the pipe
   * whenever the language is changed.
   *
   * Usage: {{ 'KEY' | translate: { maxAmount: amount } }}
   * Placeholders without a matching param are left as-is.
   */
  transform(key: any, params?: TranslateParams): any {
    const keys = key.split('.');
    let res = this.t.data;
    keys.forEach((k: any) => {
      res = res[k];
    });
    const value = res || key;

    if (!params || typeof value !== 'string') {
      return value;
    }

    return value.replace(PLACEHOLDER, (match: string, name: string) =>
      params[name] !== undefined ? String(params[name]) : match,
    );
  }
}
